import { ERouterList } from '@internal/router/constants/router-list'

import InnerLayout from '@internal/layouts/inner-layout.vue'

import { auth } from '@internal/router/middleware/auth'

export const visits = [
  {
    path: '/tasks',
    name: ERouterList.TASKS,
    component: () => import('@internal/pages/tasks/index.vue'),
    meta: {
      middleware: [auth],
      layout: InnerLayout,
    },
  },
]

export default visits
